import { styled } from '@mui/material/styles';
import { useSwimlaneRootProps } from '@/components/ui/swimlane/context';
import { AXIS_HEIGHT, COLUMN_HEADER_HEIGHT, GRID_GAP, ROW_HEADER_WIDTH } from '../constants';

// These styles allow the corner to mask the CSS grid gap
// This prevents the Card on hover shadow from bleeding past headers
const StyledDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isHeadersSticky' && prop !== 'backgroundColor',
})<{ isHeadersSticky: boolean; backgroundColor: string }>(
  ({ isHeadersSticky, backgroundColor }) => ({
    backgroundColor,
    position: isHeadersSticky ? 'sticky' : 'relative',
    gridArea: 'erase',
    zIndex: '11',
    left: `-${GRID_GAP.label}`,
    top: 0,
    boxSizing: 'content-box',
  }),
);

export function TopLeftCorner() {
  const {
    rowHeaderOrientation,
    rowHeadersWidth,
    rowHeaders,
    isHeadersSticky,
    backgroundColor,
    columnAxisLabelText,
    rowAxisLabelText,
    isAddRowHeaderButtonVisible,
  } = useSwimlaneRootProps();

  const hasRowHeaders = rowHeaders.length > 0;
  const hasAxisLabelColumn = typeof columnAxisLabelText === 'string';
  const hasAxisLabelRow = typeof rowAxisLabelText === 'string';

  const height = hasAxisLabelColumn
    ? COLUMN_HEADER_HEIGHT.value + GRID_GAP.value + AXIS_HEIGHT.value
    : COLUMN_HEADER_HEIGHT.value;
  const axisWidth = hasAxisLabelRow ? ROW_HEADER_WIDTH.vertical.value + GRID_GAP.value : 0;
  const totalWidth = hasRowHeaders
    ? rowHeaderOrientation === 'vertical'
      ? `${ROW_HEADER_WIDTH.vertical.value + axisWidth + GRID_GAP.value}px`
      : `${rowHeadersWidth + axisWidth + GRID_GAP.value}px`
    : isAddRowHeaderButtonVisible
      ? `${axisWidth + ROW_HEADER_WIDTH.vertical.value + GRID_GAP.value}px`
      : `${axisWidth + GRID_GAP.value}px`;

  return (
    <StyledDiv
      backgroundColor={backgroundColor}
      isHeadersSticky={!!isHeadersSticky}
      style={{
        width: totalWidth,
        height,
      }}
    />
  );
}
